import axios from 'axios';
import config from '@nerdwallet/app-config';
var instance = axios.create();
instance.defaults.baseURL = config.API.BASE_URLS.HOMEOWNERSHIP;
instance.defaults.timeout = 3000;
instance.defaults.params = {
  client_id: config.CLIENT_ID
};
export default instance;